import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

function RecuperarPassword({ onClose, onSuccess }) {
  const [email, setEmail] = useState('');
  const [dni, setDni] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [useEmail, setUseEmail] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/auth/recuperar-password`, 
        useEmail ? { email } : { dni }
      );

      setSuccess(response.data.message);
      
      // Cerrar el modal después de 5 segundos
      setTimeout(() => {
        onClose();
      }, 5000);
    } catch (error) {
      console.error('Error al recuperar contraseña:', error);
      setError(
        error.response?.data?.error || 'Error al recuperar contraseña'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: '#fff',
        padding: '32px',
        borderRadius: '12px',
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
      }}>
        <h2 style={{ marginBottom: '24px', color: '#212121' }}>
          Recuperar Contraseña
        </h2>

        {error && (
          <div className="alert alert-danger" style={{ marginBottom: '16px' }}>
            {error}
          </div>
        )}

        {success && (
          <div className="alert alert-success" style={{ marginBottom: '16px' }}>
            {success}
          </div>
        )}

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
            <input
              type="radio"
              checked={useEmail}
              onChange={() => setUseEmail(true)}
              style={{ marginRight: '8px' }}
            />
            Buscar por Email
          </label>
          <label style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="radio"
              checked={!useEmail}
              onChange={() => setUseEmail(false)}
              style={{ marginRight: '8px' }}
            />
            Buscar por DNI
          </label>
        </div>

        <form onSubmit={handleSubmit}>
          {useEmail ? (
            <div className="form-group" style={{ marginBottom: '16px' }}>
              <label style={{ fontWeight: 500, color: '#212121', marginBottom: '8px' }}>
                Email
              </label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@email.com"
                required
                disabled={loading}
                style={{ 
                  padding: '12px 16px',
                  fontSize: '16px',
                  borderRadius: '8px'
                }}
              />
            </div>
          ) : (
            <div className="form-group" style={{ marginBottom: '16px' }}>
              <label style={{ fontWeight: 500, color: '#212121', marginBottom: '8px' }}>
                DNI
              </label>
              <input
                type="text"
                className="form-control"
                value={dni}
                onChange={(e) => setDni(e.target.value)}
                placeholder="12345678"
                required
                disabled={loading}
                style={{ 
                  padding: '12px 16px',
                  fontSize: '16px',
                  borderRadius: '8px'
                }}
              />
            </div>
          )}

          <div style={{ 
            display: 'flex', 
            gap: '12px', 
            marginTop: '24px' 
          }}>
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              style={{
                flex: 1,
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #E0E0E0',
                background: '#fff',
                color: '#616161',
                fontSize: '16px',
                fontWeight: 500,
                cursor: 'pointer'
              }}
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                flex: 1,
                padding: '12px',
                borderRadius: '8px',
                border: 'none',
                background: '#FB8C00',
                color: '#fff',
                fontSize: '16px',
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              {loading ? 'Procesando...' : 'Recuperar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default RecuperarPassword;
